import './new-form-number-input-adornment-field.scss';
import './new-form-text-field.scss';

import { Box, FormHelperText, OutlinedInput } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

import { FC } from 'react';
import { FormFieldContainer } from './form-field-container';
import { IFormNumberFieldProps } from './form-number-field';

export interface INewFormNumberInputAdornmentField
  extends IFormNumberFieldProps {
  adornmentPosition?: 'start' | 'end';
  adornmentText: string;
  width?: string;
  isCheckBox?: boolean;
  dataTestid?: string;
  name: string;
  onBlur?: () => void;
  placeholder?: string;
  isItDismal?: boolean;
}

export const NewFormNumberInputAdornmentField: FC<
  INewFormNumberInputAdornmentField
> = ({
  adornmentPosition = 'start',
  isCheckBox,
  adornmentText,
  name,
  onBlur: onBlurProp,
  width,
  isItDismal,
  placeholder,
  ...otherProps
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState: { error } }) => {
        return (
          <FormFieldContainer md={12}>
            <OutlinedInput
              style={{ width: '80px', height: '36px' }}
              {...field}
              id="outlined-adornment-weight"
              value={field.value ? field.value : ''} // Show only the value without "%"
              placeholder={'-'} // Placeholder without "%"
              aria-describedby="outlined-weight-helper-text"
              disabled={isCheckBox}
              inputProps={{
                'aria-label': 'weight',
                sx: {
                  '&::placeholder': {
                    padding: '2px 16px', // Padding specifically for the placeholder text
                    color: 'black !important',
                  },
                },
                style: {
                  padding: isItDismal
                    ? '2.5px 0px 4px 15px'
                    : '2.5px 0px 4px 24px',
                  fontWeight: 600,
                  fontSize: '14px',
                  color: 'rgba(0, 0, 0, 0.87)',
                },
                maxLength: isItDismal ? 5 : 3, // Allow longer input for decimal numbers
              }}
              endAdornment={
                <span
                  style={{
                    color: 'black',
                    marginRight: '2px',
                    fontSize: '14px',
                    fontWeight: '600',
                  }}
                >
                  {adornmentText}
                </span>
              } // Display % as part of adornment (always shown)
              error={!!error}
              onChange={(e) => {
                const rawValue = e.target.value;
                let numericValue;

                if (isItDismal === true) {
                  numericValue = rawValue;
                } else {
                  numericValue = rawValue.replace(/\D/g, '');
                }

                field.onChange(numericValue);
              }}
              onBlur={() => {
                if (field.onBlur) {
                  field.onBlur();
                }

                if (onBlurProp) {
                  onBlurProp();
                }
              }}
            />
            {isCheckBox === true
              ? ''
              : error && (
                  <FormHelperText error>
                    {' '}
                    <Box width={width ?? '200px'}>{error.message}</Box>
                  </FormHelperText>
                )}
          </FormFieldContainer>
        );
      }}
    />
  );
};
